module.exports = __webpack_public_path__ + "static/img/345.df931748.png";